import { useMutation, useQueryClient } from "@tanstack/react-query";

import { GO_SERVICE_QUERY_KEYS } from "../queryKeys";
import { withdrawContract } from "../services/goHireService";

export const useWithdrawContract = (contractId: number, requestId: number, options?: { onSuccess?: () => void }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => withdrawContract(contractId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: GO_SERVICE_QUERY_KEYS.contractDetails(contractId) });
      queryClient.invalidateQueries({
        queryKey: [...GO_SERVICE_QUERY_KEYS.contractDetails(contractId), { contractId: contractId }],
      });
      queryClient.invalidateQueries({ queryKey: GO_SERVICE_QUERY_KEYS.serviceRequest(requestId) });
      queryClient.invalidateQueries({
        queryKey: [...GO_SERVICE_QUERY_KEYS.serviceRequest(requestId), { requestId: requestId }],
      });
      queryClient.invalidateQueries({ queryKey: GO_SERVICE_QUERY_KEYS.orderedContracts() });
      queryClient.invalidateQueries({ queryKey: GO_SERVICE_QUERY_KEYS.receivedContracts() });
      options?.onSuccess?.();
    },
    onError: () => {},
  });
};
